import { Link } from 'react-router-dom'
import logo from '@/assets/logo.jpg'
import { MAPS_URL } from '@/data/contact'
import { HERO_IMAGE_URL } from '@/data/media'


export default function HeroSection() {
  return (
    <section className="relative -mt-16 text-white flex flex-col items-center justify-center px-6 pt-32 md:pt-36 pb-28 md:pb-32 text-center overflow-hidden">
      {/* Photo de l'assemblée — image Unsplash de PRÉVISUALISATION (voir data/media.ts).
          TODO: remplacer par une vraie photo de l'assemblée du CMP, compressée pour le 3G. */}
      <img
        src={HERO_IMAGE_URL}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
        fetchPriority="high"
      />
      {/* Voile plus léger et plus chaud qu'un simple aplat navy, pour laisser deviner de vrais visages */}
      <div className="absolute inset-0 bg-linear-to-b from-cmp-navy-dark/85 via-cmp-navy/60 to-cmp-navy-dark/90" />
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            'radial-gradient(ellipse 70% 55% at 50% 30%, rgba(201,147,47,0.16) 0%, transparent 100%)',
        }}
      />

      <div className="relative z-10 max-w-3xl mx-auto flex flex-col items-center gap-6 pt-6 md:pt-10">
        <img
          src={logo}
          alt="Logo CMP"
          className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover shadow-2xl ring-4 ring-white/20"
        />

        <div>
          <p className="text-cmp-gold-light text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Centre Missionnaire Philadelphie · Lubumbashi
          </p>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold leading-[1.08] tracking-tight text-balance">
            Ici, vous êtes chez vous
          </h1>
        </div>

        <p className="text-white/85 text-base md:text-lg leading-relaxed max-w-xs md:max-w-md">
          Peu importe d'où vous venez ou ce que vous vivez : il y a une place pour vous dans
          notre famille. Venez comme vous êtes, vous êtes attendu.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 mt-2 w-full">
          <Link
            to="/premiere-visite"
            className="flex-1 bg-white text-cmp-navy font-bold px-6 py-3.5 rounded-full text-sm text-center shadow-[0_8px_24px_rgba(0,0,0,0.25)] hover:shadow-[0_10px_28px_rgba(0,0,0,0.3)] transition-shadow active:scale-95"
          >
            Planifier ma première visite
          </Link>
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 border border-white/35 bg-white/5 backdrop-blur-sm text-white font-semibold px-6 py-3.5 rounded-full text-sm text-center flex items-center justify-center hover:bg-white/15 hover:border-white/50 transition-colors active:scale-95"
          >
            Voir l'itinéraire
          </a>
        </div>

        {/* <p className="text-white/60 text-sm mt-1">On a hâte de vous rencontrer 👋</p> */}
      </div>
    </section>
  )
}
